import React from 'react';

const SecondaryColorLogo = function SecondaryColorLogo() {
  return (
    <svg
      width="13px"
      height="13px"
      viewBox="0 0 13 13"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="The-Feed-(homepage)-News" transform="translate(-1136.000000, -343.000000)" fill="#7E7E7E" fillRule="nonzero">
          <g id="Group-18-Copy" transform="translate(1111.000000, 101.778171)">
            <g id="Group-18" transform="translate(0.000000, 183.221829)">
              <path d="M37.7517182,69.5616438 L35.2725979,67.0821918 C35.9711346,66.1369863 36.3957353,64.9726027 36.3957353,63.6986301 C36.3957353,60.5479452 33.8344342,58 30.6978677,58 C27.5476043,58 25,60.5616438 25,63.6986301 C25,66.8493151 27.5613011,69.3972603 30.6978677,69.3972603 C31.957973,69.3972603 33.1358976,68.9726027 34.0809766,68.2739726 L36.5600969,70.7534247 C36.7244584,70.9178082 36.9436072,71 37.1627559,71 C37.3819047,71 37.6010535,70.9178082 37.765415,70.7534247 C38.0804414,70.4383562 38.0804414,69.890411 37.7517182,69.5616438 Z M26.6847061,63.6986301 C26.6847061,61.4931507 28.4789865,59.6986301 30.6841709,59.6986301 C32.8893552,59.6986301 34.6836356,61.4931507 34.6836356,63.6986301 C34.6836356,65.9041096 32.8893552,67.698708 30.6841709,67.698708 C28.4789865,67.7123288 26.6847061,65.9178082 26.6847061,63.6986301 Z" id="Shape" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SecondaryColorLogo;
